import Cookies from 'js-cookie';
export default class User
{
    public data;

    constructor(userData)
    {
        this.data = userData;
    }

    get primaryLocation() {
        const location = this.getLocationFromCookie();
        // Set location for Perk Search
        return location ? location : this.data.locations[0];
    }

    get isLocationCanada() {
        return this.primaryLocation.country !== "US";
    }

    get locationCookieName() {
        return 'locationState';
    }

    // Try to retrieve location from Cookies
    getLocationFromCookie() {
        if(Cookies.get('venngo_cookies')){
            const venngoCookies = JSON.parse(Cookies.get('venngo_cookies'));
            if (venngoCookies.locationState) {
                const locationState = venngoCookies.locationState;
                if(locationState.userId !== window.s.user.id){
                    return;
                }
                return locationState.savedPrimaryLocation;
            }
            return;
        }
    }

    static getCurrent() {
        return new User(window.s.user);
    }

    updateLocationCookie(location) {
        if(Cookies.get('venngo_cookies')){
            const venngoCookies = JSON.parse(Cookies.get('venngo_cookies'));
            if(venngoCookies.locationState) {
                const userLocationCookie = venngoCookies.locationState;
                if(userLocationCookie.userId !== window.s.user.id){
                    return;
                }
                userLocationCookie.savedPrimaryLocation.range = location.range;
                venngoCookies.locationState = userLocationCookie;
                Cookies.set('venngo_cookies', JSON.stringify(venngoCookies));
                return;
            }
            return;
        }
    }
}